import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Bar } from '@ant-design/plots';
import CustomCard from '@components/CustomCard';

type BarComponentProps = {
  dataBar: any;
  formatLabels: any;
  setSearchParams: any;
  title: string;
  color: string;
  field: string;
  findRealName: any;
};

export const BarComponent = ({
  dataBar,
  formatLabels,
  setSearchParams,
  title,
  color,
  field,
  findRealName,
}: BarComponentProps) => {
  const { t: translate } = useTranslation('roaming');

  const dataFormat = useMemo(() => dataBar, [dataBar]);

  return (
    <CustomCard title={translate(title)}>
      <Bar
        key="charWithProductsValuesBar"
        data={dataFormat}
        xField="value"
        yField="key"
        barWidthRatio={0.8}
        seriesField="key"
        legend={false}
        color={color}
        label={{
          content: (contentData: any) => formatLabels(contentData.value),
        }}
        meta={{
          value: {
            alias: translate('table.telephone'),
          },
          key: {
            formatter(value: any) {
              return `${value.slice(0, 20)}...`;
            },
          },
        }}
        tooltip={{
          title(titleBar) {
            return findRealName(titleBar, false)?.key || '';
          },
        }}
        barStyle={{
          radius: [6, 6, 0, 0],
        }}
        minBarWidth={10}
        onReady={plot => {
          plot.on('plot:click', (evt: any) => {
            const { x, y } = evt;
            const tooltipData = plot.chart.getTooltipItems({
              x,
              y,
            });
            setSearchParams({
              [field]: tooltipData[0].title,
            });
          });
        }}
      />
    </CustomCard>
  );
};
